import type { Guide, GuideRecordHint } from '../types';

/** S-21.10-02 — okno kontroli prezlecenia (scenariusz e2e 16, ścieżki ADM-06, ADM-08, MIX-01). */
const PRE_ORDER: GuideRecordHint = {
  description: 'prezlecenie z kolejki „Do kontroli” — albo dowolne prezlecenie z listy',
  listPath: '/pre-orders',
  listFilter: { intakeQueue: 'adm_control' },
};

export const guide: Guide = {
  flagKey: 'intakeControlWindow',
  title: 'Okno kontroli prezlecenia',
  whatItDoes:
    'Jedno okno ze wszystkim, co sprawdzamy przed zapisem do VIA: pola, bez których importer nie przyjmie pliku, rekomendowana stawka VAT z uzasadnieniem, podobne zlecenia (duplikat), podgląd plików i stan zapisu. Zatwierdzenie i plik — tymi samymi przyciskami co na zleceniu. Numer zlecenia nadaje TMS, więc wynik zapisu widać dopiero po imporcie („Jest w TMS”).',
  audience: ['Administracja', 'CS'],
  presentationItems: ['S-21.10-02'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/show',
      record: PRE_ORDER,
      target: 'pre-order-control-window',
      title: 'Wejście do okna kontroli',
      description: 'Na karcie prezlecenia przycisk „Okno kontroli” otwiera kontrolę przed zapisem do VIA.',
      action: 'Kliknij „Okno kontroli”.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'b1PreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: PRE_ORDER,
      target: 'control-blockers',
      title: 'Pola blokujące zapis',
      description:
        'Lista pól, bez których importer VIA nie przyjmie pliku — osobno dla pliku zlecenia i pliku czynności wózkowej. Dopóki lista nie jest pusta, plik nie powstanie.',
      action: 'Sprawdź listę braków; uzupełnij je w „Dane dla importera”.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'b1PreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: PRE_ORDER,
      target: 'control-vat',
      mockupTestId: 'adm-zlecenie-decyzja-vat',
      title: 'Rekomendowana stawka VAT',
      description:
        'Stawka z krajów spółki, kontrahenta, załadunku i rozładunku, z uzasadnieniem. To podpowiedź, nie zapis — stawkę wpisuje Administracja w TMS.',
      action: 'Porównaj stawkę z tym, co wpiszesz w TMS.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'vatPreOrders.plde' } },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: PRE_ORDER,
      target: 'control-files',
      title: 'Pliki dla VIA',
      description:
        'Podgląd plików, które powstaną. Zlecenie z wózkiem to dwa pliki: transport i czynność wózkowa — numery obu rekordów nadaje TMS przy imporcie.',
      action: 'Rozwiń podgląd pliku, zanim go zatwierdzisz.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'b1PreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: PRE_ORDER,
      target: 'control-state',
      title: 'Stan zapisu do VIA',
      description:
        'Czy plik powstał, dotarł, czy był błąd — z ponowieniem. Natychmiastowego wyniku z TMS nie ma: zlecenie pokazuje się jako „Jest w TMS” po imporcie.',
      action: 'Po zatwierdzeniu kliknij „Wytwórz pliki” i wróć tu po imporcie z TMS.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'b1PreOrderId' } },
    },
  ],
};
